/*
 * <cart-flavor-upsell> — upsell card in the cart drawer.
 *
 * snippets/cart-flavor-upsell.liquid renders one HIDDEN candidate per upsell
 * variant that isn't in the cart yet, recomputed server-side on every cart
 * render. This element reveals exactly ONE of them: a [data-upsell-priority]
 * candidate (the Sample bag) when there is one, otherwise one at random, so
 * the suggestion rotates as the cart changes; with no candidate left the
 * snippet emits nothing and the card disappears on its own.
 *
 * Adding posts to /cart/add with the selling plan the snippet resolved (the
 * cart's own purchase type, or none for one-time-only products), then
 * publishes cartUpdate so the drawer,
 * the header badge and skio-cart-plan-sync.js all catch up.
 */
if (!customElements.get('cart-flavor-upsell')) {
  customElements.define(
    'cart-flavor-upsell',
    class CartFlavorUpsell extends HTMLElement {
      connectedCallback() {
        if (this.revealed) return;
        this.revealed = true;

        const candidates = Array.from(this.querySelectorAll('[data-upsell-candidate]'));
        if (!candidates.length) return;

        const prioritized = candidates.filter((candidate) => candidate.hasAttribute('data-upsell-priority'));
        const pool = prioritized.length ? prioritized : candidates;
        const chosen = pool[Math.floor(Math.random() * pool.length)];
        candidates.forEach((candidate) => {
          if (candidate === chosen) {
            candidate.removeAttribute('hidden');
          } else {
            candidate.remove();
          }
        });

        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-upsell-add]');
          if (button) this.addToCart(button);
        });
      }

      addToCart(button) {
        if (button.getAttribute('aria-busy') === 'true') return;

        const item = { id: button.dataset.variantId, quantity: 1 };
        if (button.dataset.sellingPlanId) item.selling_plan = button.dataset.sellingPlanId;

        const config =
          typeof fetchConfig === 'function'
            ? fetchConfig('javascript')
            : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' } };

        button.setAttribute('aria-busy', 'true');

        fetch(routes.cart_add_url, { ...config, body: JSON.stringify({ items: [item] }) })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) throw new Error(response.description || response.message);
            return fetch(`${routes.cart_url}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
          })
          .then((cart) => {
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-flavor-upsell', cartData: cart });
            }
          })
          .catch((error) => {
            console.error('Cart flavor upsell: add failed', error);
            const errors = document.getElementById('CartDrawer-CartErrors');
            if (errors) {
              errors.textContent =
                (window.cartStrings && window.cartStrings.error) || 'There was an error updating your cart.';
            }
            button.removeAttribute('aria-busy');
          });
      }
    }
  );
}
